module.exports = __webpack_public_path__ + "static/media/2021.Security.Son.ObliCheck.7350dc55.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/2021.Security.Son.ObliCheck.pdf
// module id = 67
// module chunks = 0